import "@babel/polyfill";

window.Vue = require('vue');

import store from './store';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


import alert from './components/alerts/AlertComponent.vue';
Vue.component('alert', alert);

import alertBridge from './components/bridge/AlertBridgeComponent.vue';
Vue.component('alert-bridge', alertBridge);

Vue.component('accordion-component', require('./components/ulteriors/AccordionComponent.vue').default);
Vue.component('accordion-item-component', require('./components/ulteriors/AccordionItemComponent.vue').default);
Vue.component('product-carousel-component', require('./components/ulteriors/ProductCarouselComponent.vue').default);
Vue.component('gallery-modal-component', require('./components/ulteriors/FancyboxWrapper.vue').default);
Vue.component('swiper-carousel-component', require('./components/SwiperCarouselComponent.vue').default);
Vue.component('product-calculator', require('./components/ProductCalculator.vue').default);
Vue.component('product-buying-options', require('./components/ProductBuyingOptions.vue').default);
Vue.component('product-variations', require('./components/ProductVariations.vue').default);
Vue.component('product-variations-filter', require('./components/ProductVariationsFilter.vue').default);
Vue.component('favouritebutton', require('./components/FavouriteButtonComponent.vue').default);
Vue.component('minifavouritebutton', require('./components/MiniFavouriteButtonComponent.vue').default);
Vue.component('favourites', require('./components/FavouritesComponent.vue').default);
Vue.component('minicart', require('./components/MiniCart.vue').default);
Vue.component('shopping-basket', require('./components/ShoppingBasket.vue').default);
Vue.component('checkout-form', require('./components/CheckoutForm.vue').default);
Vue.component('payment-component', require('./components/PaymentComponent.vue').default);
Vue.component('paypal-component', require('./components/PayPalComponent.vue').default);
//Vue.component('stripe-component', require('./components/StripeComponent.vue').default);
Vue.component('payment', require('./components/Payment.vue').default);
Vue.component('standalone-payment', require('./components/StandAlonePayment.vue').default);
Vue.component('sample', require('./components/SampleItemComponent.vue').default);

var elementExists = document.getElementById("app");

if (elementExists) {
	const app = new Vue({
	   el: '#app',
	   store
	});
}
